import { TabInfo } from "../../models/favorites"

export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export const TABS_CONFIG: TabInfo[] = [
  { key: 'resources', resourceType: 'resource', path: 'biblioteca', imagePath: 'resources' },
  { key: 'courses', resourceType: 'course', path: 'cursos', imagePath: 'courses' },
  { key: 'novelties', resourceType: 'novelty', path: 'novedades', imagePath: 'novelties' },
  { key: 'news', resourceType: 'novelty', path: 'noticias', imagePath: 'novelties' },
  { key: 'offers', resourceType: 'offer', path: 'ofertas', imagePath: 'offers' },
  { key: 'catalogs', resourceType: 'resource', path: 'biblioteca', imagePath: 'resources' },
  { key: 'seminars', resourceType: 'seminar', path: 'seminarios', imagePath: 'seminars' }
]
